<!--TODO: Need to refactor: this code the same as wgnp/static_source/components/sms_resend_code/sms_resend_code.vue.html-->
<div class="two-fa-steps_switcher">
    <a
        @click.prevent="toggleTip"
        href="#"
        class="b-link-false b-link-false__minor b-link_dashed"
        data-at-role="code_not_received">{{ gettext('Не пришел код?') }}</a>

    <div class="two-fa-steps_hidden" :class="{ 'two-fa-steps_hidden__open': showTip }">

        <slot></slot>

        <b-message-error
            v-if="errorType.requestCode"
            :errorParams="{ template: errorsTemplates.requestCode }" />

        <fieldset class="form-fieldset form-fieldset__incontent">
            <button
                @click.prevent="requestNewCode"
                :class="{ disable: requestButtonDisabled || isTimerActive}"
                class="antique-button antique-button__mobile-submit"
                data-at-role="request_new_sms"
                :disabled="isTimerActive">
                <spinner :modifiers="['big-button']" v-if="processing"></spinner>
                {{ gettext('Запросить код') }}
            </button>
        </fieldset>

        <two-factor-timer
            :key="'two-fa-timer-' + timerKey"
            ref="twoFactorTimer"
            :resend-available-at="timerResendAvailableAt"
            :window-available-at="timerWindowAvailableAt"
            :is-last-attempt="timerIsLastAttempt"
            @toggle-button="isTimerActive = $event"
        />
    </div>
</div>
